module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            404\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Whoops! Something went wrong ...\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n            We could not find what you were looking for.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_vm._v("\n                Go to homepage\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-301a1469"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/404.vue
// module id = 284
// module chunks = 1